import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { primitiveColors } from '@/theme/tokens';

interface GradientCircularProgressProps {
  size?: number;
  thickness?: number;
}

const GradientCircularProgress: React.FC<GradientCircularProgressProps> = ({ size, thickness }) => (
  <>
    <svg width={0} height={0} style={{ position: 'absolute' }}>
      <defs>
        <linearGradient id="my_gradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor={primitiveColors.blue3} />
          <stop offset="33%" stopColor={primitiveColors.purple1} />
          <stop offset="66%" stopColor={primitiveColors.red1} />
          <stop offset="100%" stopColor={primitiveColors.purple2} />
        </linearGradient>
      </defs>
    </svg>
    <CircularProgress
      size={size}
      thickness={thickness}
      sx={{ 'svg circle': { stroke: 'url(#my_gradient)' } }}
    />
  </>
);

export default GradientCircularProgress;
